{
  "RESET_PASSWORD": {
    "TITLE": "Obnovit heslo",
    "DESCRIPTION": "Zadejte e-mailovou adresu, kterou používáte k přihlášení do kontaktního centra, abyste získali pokyny k obnovení hesla.",
    "GO_BACK_TO_LOGIN": "Pokud se chcete vrátit na přihlašovací stránku,",
    "EMAIL": {
      "LABEL": "E-mailová adresa",
      "PLACEHOLDER": "Prosím, zadejte svůj e-mail.",
      "ERROR": "Zadejte prosím platný e-mail."
    },
    "API": {
      "SUCCESS_MESSAGE": "Odkaz pro obnovení hesla byl odeslán na váš e-mail.",
      "ERROR_MESSAGE": "Nelze se připojit k chat serveru, opakujte akci později"
    },
    "SUBMIT": "Odeslat"
  }
}